export const GOOGLE_MAP_API_KEY = 'AIzaSyDr3jigERXokEhyue_BsS3FuFDPDZaHq1I'